/* RESPONSIBLE TEAM: team-automation-foundations */
import AutomationFinAIAgentAttributesAttributeRoute from 'embercom/routes/apps/app/automation/fin-ai-agent/attributes/attribute';

export default AutomationFinAIAgentAttributesAttributeRoute;
